import { SVGProps } from 'react'

export const AnnotationIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.9075 11.1743V12.0375C15.9075 14.3025 14.49 15.9 12.225 15.9H5.7375C3.4725 15.9 2.0625 14.3025 2.0625 12.0375V5.92425C2.0625 3.65925 3.48 2.0625 5.7375 2.0625H12.225"
      stroke="#3F3F46"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.9075 7.99414V5.74414"
      stroke="#3F3F46"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.9037 2.89746H15.9112"
      stroke="#3F3F46"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.96094 12.3227L5.10694 11.113C5.50519 10.6907 6.16894 10.6705 6.59194 11.068C6.60469 11.0807 7.29469 11.782 7.29469 11.782C7.71094 12.2057 8.39119 12.2125 8.81494 11.797C8.84269 11.77 10.5654 9.68049 10.5654 9.68049C11.0094 9.14124 11.8067 9.06399 12.3467 9.50874C12.3827 9.53874 14.0102 11.209 14.0102 11.209"
      stroke="#3F3F46"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
)
